import { render, staticRenderFns } from "./carouselChart.vue?vue&type=template&id=7f8b90d4&scoped=true&"
import script from "./carouselChart.vue?vue&type=script&lang=js&"
export * from "./carouselChart.vue?vue&type=script&lang=js&"
import style0 from "./carouselChart.vue?vue&type=style&index=0&id=7f8b90d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8b90d4",
  null
  
)

export default component.exports